import { addZero, isTablet } from '@/modules/functions';
import { Navigation, Swiper } from 'swiper';

export class Benefits {
  list;
  slider;
  total;
  current;

  constructor() {}

  init() {
    this.list = document.querySelector('.home-benefits-list');
    if (!this.list) return;

    this.current = document.querySelector(
      '.home-benefits-slider-navigation-count-current'
    );
    this.total = document.querySelector(
      '.home-benefits-slider-navigation-count-total'
    );

    Swiper.use([Navigation]);

    if (isTablet()) {
      this.createSlider();
    } else {
      this.createDesktopHoverImage()
    }
  }

  createDesktopHoverImage() {
    this.list.querySelectorAll('.home-benefits-item-image').forEach((el) => {
      const img = el.querySelector('img');
      img.className = 'home-benefits-item-image-static';
      const cloneImg = img.cloneNode();
      cloneImg.className = 'home-benefits-item-image-hover';
      el.append(cloneImg);
    })
  }

  createSlider() {
    this.list.querySelectorAll('.home-benefits-item').forEach((el) => {
      el.classList.add('swiper-slide');
    });
    const items = this.list.innerHTML;
    this.list.innerHTML = `<div class="swiper home-benefits-slider"><div class="swiper-wrapper">${items}</div></div>`;

    this.total.innerText = addZero(
      this.list.querySelectorAll('.swiper-slide').length
    );
    this.current.innerText = addZero(1);

    this.slider = new Swiper('.home-benefits-slider', {
      slidesPerView: 1,
      navigation: {
        prevEl: '.home-benefits-slider-navigation-controls-prev',
        nextEl: '.home-benefits-slider-navigation-controls-next',
      },
      on: {
        slideChange: (swiper) => {
          this.current.innerText = addZero(swiper.activeIndex + 1);
        },
      },
    });
  }
}
